import { colors } from 'styles/colors';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;

  .gatsby-image-wrapper {
    height: 55vh;
    min-height: 320px;
    max-height: 760px;

    @media (min-width: 768px) {
      height: 70vh;
    }
  }
`;

// Sits in the open sky at the top of the photo
export const Title = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding-top: 2rem;
  color: ${colors.ink};

  @media (min-width: 992px) {
    padding-top: 4rem;
  }

  h1 {
    margin: 0 0 0.25rem;
    font-size: 3rem;
    line-height: 1.1;

    @media (min-width: 992px) {
      font-size: 4.5rem;
    }
  }

  p {
    margin: 0;
    font-size: 1.125rem;

    @media (min-width: 992px) {
      font-size: 1.375rem;
    }
  }
`;
